import { Logger } from "@iloq/shared";

const GDPR_CONSENT_KEY = "gdprConsent";

export default class GDPRStore {
  static loadGdprConsent(): boolean | null {
    const consent = localStorage.getItem(GDPR_CONSENT_KEY);
    Logger.debug(`Fetching GDPR consent value: ${consent}`);
    return consent === "true" || null;
  }

  static saveGdprConsent(consent: boolean): void {
    Logger.debug(`Storing GDPR consent value "${consent}"`);
    localStorage.setItem(GDPR_CONSENT_KEY, consent.toString());
  }

  static removeGdprConsent(): void {
    localStorage.removeItem(GDPR_CONSENT_KEY);
  }
}
